<template>
    <div >
        <!-- {{ forms.input.profileLogoMentor.name }} -->
                    <!-- content -->    <!-- content -->    <!-- content -->
                    <div class="fontnormal2"  style="font-size:30px !important;">
                       Summary
                        <div class="underline"></div>
                    </div>
                    <br>
                    <br>
                     <div class="fontnormal2">
                        <strong>Who are you?</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div @click="gopath('Who are you?')"   class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="containeralldetail"> 
                     <div class="fontnormal2">     
                         Who are you? 
                         <span style="padding-left: 15px;">
                          <span v-if="forms.input.whoAreYou.length > 0" v-for="(val,index) in forms.input.whoAreYou" class="fontblue">{{ `${val.label} ${comma('whoAreYou',index)}`  }}</span>
                         </span>
                     </div>
                      <div class="fontnormal2">
                         Do you love to be a volunteer?
                         <span style="padding-left: 15px;">
                          <span v-if="forms.input.loveVolunteer.length > 0" v-for="(val,index) in forms.input.loveVolunteer" class="fontblue">{{ `${val.label} ${comma('loveVolunteer',index)}`  }}</span>
                         </span>
                     </div>
                      <div class="fontnormal2">
                         Why do you want to be a volunteer?
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-if="forms.input.wantVolunteer.length > 0" v-for="(val,index) in forms.input.wantVolunteer" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>
                    <div class="fontnormal2" style="margin-top: -16px;">
                         Hourly Rate
                         <span class="fontblue" style="padding-left: 15px;" v-if="forms.input.hourlyRateAmount != null && forms.input.hourlyRate != null">
                          {{ `${forms.input.hourlyRate.label} ${forms.input.hourlyRateAmount} / hour`}}
                         </span>
                     </div>
                     <div class="fontnormal2">
                         Industry interested
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-if="forms.input.areYouInterestedInInvesting.legnth > 0" v-for="(val,index) in forms.input.areYouInterestedInInvesting" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>
                            <b-button v-if="val.label == 'Other'"  type="is-info" class="blueoutline" outlined>
                            {{ `Other : ${val.des}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>
                       
                    <!-- 
                     <div v-if="forms.input.otherinvest" class="fontnormal2" style="margin-top: -16px;">
                         Other
                         <span class="fontblue" style="padding-left: 15px;">
                          {{ `${forms.input.otherinvest}`}}
                         </span>
                     </div> -->

                      <div class="fontnormal2" style="margin-top: 10px;">
                         Which size of investment you are?
                          <div >
                            <div v-if="forms.input.whichSizeOfInvestment.legnth > 0" v-for="(val,index) in forms.input.whichSizeOfInvestment" class="fontblue" style="display:block;margin-top:5px">
                            {{ `${val.label}`  }}
                           </div>
                           </div>
                        </div>
                     <br>
                     <div class="fontnormal2">
                         <strong>Basic profile</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div @click="gopath('Basic profile')" class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="containimg">
                      
                      <div class="imgprofile" :style="{ backgroundImage: 'url('+ imgPath + forms.input.profileLogoMentor.name + ')' }">
                        </div>
                        
                    </div>
                    <br>
                     
                    <div class="fontnormal2">
                      <div class="columns">
                             <div class="column" v-if="forms.input.nameMentor">Name <span class="fontblue">{{ forms.input.nameMentor }} </span></div>
                            <div class="column" v-if="forms.input.Surename">Surename <span class="fontblue">{{ forms.input.surenameMentor }}</span></div>
                        </div>
                        <div class="columns">
                             <div class="column" v-if="forms.input.Nickname">Nickname <span class="fontblue">{{ forms.input.nicknameMentor }} </span></div>
                            <div class="column" v-if="forms.input.dateofBirthMentor">Date of birth <span class="fontblue">{{ forms.input.dateofBirthMentor | formatDate }} </span></div>
                        </div>
                          <div class="columns">
                             <div class="column" v-if="forms.input.livingInMentor && forms.input.livingInMentor != null">Living in <span class="fontblue">{{ forms.input.livingInMentor.label }} </span></div>
                            <div class="column" v-if="forms.input.countryMentor != null && forms.input.countryMentor.label">Country <span class="fontblue">{{ forms.input.countryMentor.label }} </span></div>
                        </div>
                        <div class="columns">
                             <div class="column" v-if="forms.input.genderMentor.data != null">Gender <span class="fontblue">{{ forms.input.genderMentor.data.label }} </span></div>
                            <div class="column" v-if="forms.input.countryCode != nul && forms.input.telephoneNumberMentor != null">Telephone number <span class="fontblue">{{ forms.input.countryCode+''+forms.input.telephoneNumberMentor }} </span></div>
                        </div>
                        <div class="columns">
                             <div class="column" v-if="forms.input.emailMentor != null">E-mail <span class="fontblue">{{ forms.input.emailMentor }} </span></div>
                        </div>
                         <div class="columns">
                             <div class="column" v-if="forms.input.websiteMentor != null">  Website (Optional) <span class="fontblue">{{ forms.input.websiteMentor }} </span></div>
                        </div>
                     </div>

                      <br>
                     <div class="fontnormal2">
                         <strong>Introduction</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div @click="gopath('Introduction')" class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                     <div class="fontnormal2">     
                         About me (Limited to 300 characters)
                         <div>
                         <div class="fontblue" style="padding:0;margin:10px 0 0 0;">
                            {{ forms.input.anoutMe  }} 
                         </div>
                         </div>
                     </div>
                      <div class="fontnormal2">     
                         Profession title
                         <div>
                         <div class="fontblue" style="padding:0;margin:10px 0 0 0" v-if="forms.input.professionTitle != null">
                            {{ forms.input.professionTitle  }} 
                         </div>
                         </div>
                      </div>

                         <!-- {{ forms.input }} -->
                      <div class="fontnormal2">
                         Industry Expertise
                         <span style="padding-left: 15px;">
                             <div >
                            <div v-if="forms.input.industryexpertise.length > 0" v-for="(val,index) in forms.input.industryexpertise" class="fontblue" style="display:inline-block">
                               <b-button  type="is-info" class="blueoutline" outlined>
                            {{ `${val.label}`  }}
                            </b-button>

                              <b-button  v-if="val.label == 'Other'"  type="is-info" class="blueoutline" outlined>
                            {{ `Other : ${val.des}`  }}
                            </b-button>
                           </div>
                           </div>
                         </span>
                     </div>

                     <div class="fontnormal2" style="padding:0;margin:20px 0 0 0;font-weight:bold" >  
                        Social profiles
                     </div>
                    <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Facebook 
                         <span style="padding-left: 15px;">
                             <span class="fontblue" v-if="forms.input.facebookMentor != null"> {{ forms.input.facebookMentor  }} </span> 
                         </span>
                     </div>
                       <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Linkedin 
                         <span style="padding-left: 15px;">
                             <span class="fontblue"  v-if="forms.input.linkedinMentor != null"> {{ forms.input.linkedinMentor  }} </span> 
                         </span>
                     </div>
                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Line 
                         <span style="padding-left: 15px;">
                             <span class="fontblue" v-if="forms.input.lineMentor != null"> {{ forms.input.lineMentor  }} </span> 
                         </span>
                     </div>
                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Skype 
                         <span style="padding-left: 15px;">
                             <span class="fontblue" v-if="forms.input.skypeMentor != null"> {{ forms.input.skypeMentor  }} </span> 
                         </span>
                     </div>
                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Hangouts 
                         <span style="padding-left: 15px;">
                             <span class="fontblue" v-if="forms.input.hangoutsMentor != null"> {{ forms.input.hangoutsMentor  }} </span> 
                         </span>
                     </div>
                     <div class="fontnormal2" style="padding:0;margin:10px 0 0 0">     
                         Zoom 
                         <span style="padding-left: 15px;">
                             <span class="fontblue" v-if="forms.input.zoomMentor != null"> {{ forms.input.zoomMentor  }} </span> 
                         </span>
                     </div>

                     
                      <br>
                     <div class="fontnormal2">
                        <strong>Language</strong> 
                        <div class="underline"></div>
                        <div class="edit"> 
                            <div @click="gopath('Language')"  class="fontnormal2" >
                               <i style="" class="fas fa-pen"></i>   Edit
                            </div>
                        </div>
                    </div>
                    <br>
                     <div class="fontnormal2">     
                         Talk well in
                         <span style="padding-left: 15px;">
                          <span v-if="forms.input.talkWellInMentor.length" v-for="(val,index) in forms.input.talkWellInMentor" class="fontblue">{{ `${val.label} ${comma('talkWellInMentor',index)}`  }}</span>
                         </span>
                     </div>
                    </div>
                    <!-- @click="gopath('/signupsuccess')" -->
                    <b-button @click="confirmdata"  class="buttonorange" style="margin:25px 0 0 0;"  type="is-primary">CONFIRM</b-button>
                       <!-- content -->    <!-- content -->    <!-- content -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import {HTTP,HTTPDynamic,HTTPMentor} from "@/axios.js";

export default{
    data() {
        return {
            forms:[],
            imgPath:process.env.VUE_APP_IMG_PROFILE,
            loopmenu:[{
                label:'Who are you?',
                // menu:'whoareyou'
                },{
                    label:'Basic profile',
                    // menu:'basicprofile'
                },{
                    label:'Introduction',
                    // menu:'introduction'
                },{
                    label:'Language',
                    // menu:'language'
                }],
        }
    },
    props:[
        'changepage',
        // 'editpage',
    ],
    computed: {
         ...mapState(["beforedataform","token","formId","senddatamentor","islogin"]),
    },
    methods:{
        comma(name,index){
           if(this.forms.input[name].length > 1){
               if(this.forms.input[name].length != index+1){
                   return `,`
               }else{
                    return ''
                  
               }
           }
           return ''
        },
        confirmdata(){
            this.$dialog.confirm({
            message: 'Do you want to save the data ?',
            onConfirm: () => {
            //console.log('senddatamentorsenddatamentor',JSON.stringify(this.senddatamentor))
            // token
            HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.islogin.token}`
            HTTPMentor.post(`create/detail/user`,this.senddatamentor).then(res => {
              if(res.data.success){
                  console.log(res)
                // this.signup = {}
                // this.sendeditprofile()
                this.$dialog.alert('<p class="has-text-centered is-size-5">Update Successfully</p>');
                this.$router.push('/signupsuccess')
              }else{
                this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
                console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
             });

            }
            })

        },
        sendeditprofile(){
            let data = {
                userId:this.islogin.userId,
                name: this.islogin.name,
                surname : this.islogin.surname,
                profilePic: this.islogin.profilePic
            }
            console.log('czxczxcxzs',data)
            
             HTTPMentor.post(`update/account`,data).then(res => {
              if(res.data.success){
                  console.log(res)
                // this.signup = {}
                
              }else{
                // this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
                console.log("api/add/kpi/error",e);
                // this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
             });


        },
        gopath(val){
            if(val == '/signupsuccess'){
                  this.$dialog.confirm({
                    message: 'Do you want to save the data ?',
                    onConfirm: () => {
                         this.$router.push(val)
                             
                        }
                })
            }else{
                var isedit = true;
            var data = {
                label : val,
                isedit,
            }

            this.$emit('editpage',false)
            this.$emit('changepage',data)
            // this.$store.commit('selectmenu',data)
            console.log(val)
            }
            
        },
    },
    created(){

      this.forms = this.beforedataform
       console.log('this.forms',JSON.stringify(this.forms))
      console.log('this.forms',this.forms)
    }
}
</script>
<style scoped>
.pd-5{
    padding: 2.3rem!important;
}
.menu-list a:hover{
    width: 139%;
    box-shadow: 0 0 0 1px white;
    border-radius: 42px;
}

.menu-list a:hover span.icon{
           right: 27% !important
}


.menu-list a.activemenu:hover{
           width: 139%;
    border: none;
}

.menu-list a{
        width: 139%;
    color: white ;
}
.menu-list{
        margin: 19px 0;
}
.fontnormal2 .column{
    padding: 0;
    /* margin:0; */
}
.fontnormal2 .columns{
        margin: 0 0 10px 0;
}
.center .columns{
    text-align: left
}
.containimg{
    height: 100%;
    display: flex;
    justify-content: center;
}
.blueoutline:hover,.blueoutline:focus,.blueoutline{
   border-radius: 21px !important;
    border-color: #0D6ACA !important;
    color: #0D6ACA !important;
    background: white !important;
    margin-top: 10px;
}
.fontblue .blueoutline:nth-child(n+1){
    margin-left: 10px;
}
.containeralldetail .fontnormal2:nth-child(n+1){
margin-top: 5px;
}
.underline{
  position: absolute;
  bottom: -15px;
  width: 100%;
  background: #F3F3F3;
  height: 1px;
}

.fontnormal2{
    position: relative;
    color: #000000 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.fontnormal2 .fontblue{
     position: relative;
    color: #0D6ACA !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
    margin-left: 5px;
    
}
.edit{
    cursor: pointer;
    float:right
}
.edit i{
color:#C4C4C4
}
.edit .fontnormal2{
    position: relative;
    color:#C4C4C4 !important;
    font-size: 20px !important ;
    font-weight: normal;
    text-align: left;
}
.buttonorange{
     padding: 5px 2rem;
    font-weight: 600;
    background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
    border-radius: 40px;
    margin: 0 auto;
    display: block;
}
.level.is-mobile{
    margin-top: 10px;
}
.level-item{
    margin-right: 0.55rem;
}
i{
  color: #0d6aca;
  justify-content: center;
  
}
.circle{
        border-radius: 50%;
    background: white;
    text-align: center;
    width: 30px;
    font-size: 13px;
    height: 28px;
    display: flex;
    position: relative;
        justify-content: center;
    align-items: center;
}

.fontnormal{
  font-family: 'Raleway';
font-size: 14px;
color: #FFFFFF;
}

.bgcolor{
    overflow: hidden !important;
    border-color: white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
    min-height: 100vh;
}
.fontbold{
 font-family: 'Raleway';
  font-weight: bold;
font-size: 14px;
color: white;
}
.textprofile{
    float: left;
    width: calc( 100% - 140px);
    min-height: 140px;
    padding: 20px 10px 10px 20px;
}
.title{
        color: white;
    padding-left: 11px;
    font-weight: bold;
     margin-bottom: 1.5rem;
}
.imgprofile{
    float: left;
    /* background: #89C3FE; */
    /* background: url("../../assets/Intersect.png"); */
    background-repeat: no-repeat;
    background-size: cover;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    width: 170px;
    height: 170px;
    border-radius: 70px;
}

.bgcolor{
    overflow:hidden !important;border-color:white !important;
    background-image: linear-gradient(#0d6aca, #0fb7f3);
    min-height: 100vh;
}
.buttonc{
  padding-left: 2rem;
  padding-right: 2rem;
  background: linear-gradient(180deg, #FD7900 -34.44%, #FFCB2A 133.33%);
  border-radius: 40px;
}

.menu-list .iconcustom{
    right: 27% !important;
}
</style>
